import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'

interface UseMaintenanceEstablishmentChoiceManualEntryProposalsClientCancelProps {
  proposalId: string
  options?: Partial<Omit<UseMutationOptions<unknown, ErrorResponse>, 'mutationKey' | 'mutationFn'>>
}

export const useMaintenanceEstablishmentChoiceManualEntryProposalsClientCancel = ({
  proposalId,
  options,
}: UseMaintenanceEstablishmentChoiceManualEntryProposalsClientCancelProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['maintenanceEstablishmentChoiceManualEntryProposalsClientCancel'],
    mutationFn: () => {
      return privateAxios.put(`/maintenance/establishment_choice/manual_entry_proposals/${proposalId}/cancel`)
    },
    ...options,
  })
}
